import { NodeSearchParams, openNode } from '../../utility/TreeNavigation'
import { ILeaf, INode } from 'shared/types/tree'
import { Box, Button } from '@mui/material'
import { ConfirmCommitButton } from 'shared/ui'
import React from 'react'
import { ResizableImage } from '../../utility/ResizableImage'
import { altTextIdMapAtom, altTextSourceDataAtom, byUrlDataAtom } from './atoms'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'

const TitleBox = ({
  title,
  content,
}: {
  title: string
  content?: string | null
}) => (
  <Box>
    <Box>
      <strong>{title}</strong>
    </Box>
    <Box>{content}</Box>
  </Box>
)

// SelectedUrl - displays useful information and links for a url
// including current alt text, generated alt text, url
// From this component you can navigate to any node or leaf that contains the url
export function SelectedUrl({
  url,
  onDeselect,
  leafSelectFunc,
  nodeSelectFunc,
}: {
  url: string
  onDeselect(): void
  leafSelectFunc?: (leaf: ILeaf, url: string) => Promise<void>
  nodeSelectFunc?: (node: INode, url: string) => Promise<void>
}) {
  const idMap = useAtomValue(altTextIdMapAtom)
  const allUrlData = useAtomValue(byUrlDataAtom)
  const sourceData = useAtomValue(altTextSourceDataAtom)

  const urlData = allUrlData[url]
  if (!urlData) return null
  const go = (node: NodeSearchParams) => openNode(node, idMap)

  return (
    <Box style={{ border: 'solid 1px', padding: 10 }}>
      <Button onClick={onDeselect}>X</Button>
      <Box>
        <ResizableImage src={url} />
      </Box>
      <Box padding="5px">
        <TitleBox title="Existing Alt Text" content={urlData.altText} />
      </Box>
      <Box padding="5px">
        <TitleBox title="New Alt Text" content={sourceData[url]?.altText} />
      </Box>
      <Box padding="5px">
        <TitleBox title="URL" content={urlData.url} />
      </Box>
      <Box padding="5px" style={{ border: 'solid 1px' }}>
        <Box>Located in these nodes/leaves</Box>
        {urlData.nodes.map((node) => {
          const { id, title } = node
          return (
            <Box key={id}>
              {title}
              <Button onClick={() => go(node)}>Go</Button>
              {nodeSelectFunc && (
                <ConfirmCommitButton onClick={() => nodeSelectFunc(node, url)}>
                  Update
                </ConfirmCommitButton>
              )}
            </Box>
          )
        })}
        {urlData.leaves.map((leaf) => {
          const { id } = leaf
          return (
            <Box key={id}>
              Leaf
              <Button onClick={() => go(leaf)}>Go</Button>
              {leafSelectFunc && (
                <ConfirmCommitButton onClick={() => leafSelectFunc(leaf, url)}>
                  Update
                </ConfirmCommitButton>
              )}
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
